<template>
  <b-modal
    ref="modal-show-screenshot"
    id="modal-show-screenshot"
    class="modal-show-screenshot"
    size="xl"
    hide-footer
    hide-header
    centered
  >
    <div
      data-testid="icon-close-screenshot"
      class="icon-close cursor-pointer"
      @click="hideModal"
    >
      <feather-icon
        icon="XIcon"
        size="16"
      />
    </div>
    <div>
      <b-img
        data-testid="popup-screenshot"
        :src="img"
        alt="store-screenshot"
        class="img-screenshot"
      />
    </div>
  </b-modal>
</template>
<script>
/* eslint-disable camelcase */
import {
  BModal,
  BImg,
} from 'bootstrap-vue'

export default {
  components: {
    BModal,
    BImg,
  },
  props: {
    img: {
      type: String,
      required: true,
    },
  },

  methods: {
    hideModal() {
      this.$refs['modal-show-screenshot'].hide()
    },

    showModal() {
      this.$refs['modal-show-screenshot'].show()
    },
  },
}
</script>
<style lang="scss" scoped>
.btn-hide{
  position: absolute;
  top: -12px;
  right: -12px;
}
.img-screenshot {
  max-height: calc(100vh - 3.5rem);
  max-width: 100%;
  border-radius: 8px;
}

.icon-close {
  color: white;
  position: absolute;
  top: -12px;
  right: -12px;
  border-radius: 100px;
  background-color: #4d4d6c;
  line-height: 0;
  padding: 4px;
}

</style>
<style lang="scss">
#modal-show-screenshot {
  .modal-dialog {
    justify-content: center;
    @media(min-width: 1200px) {
      margin-right: 10%;
      margin-left: 10%;
    }
  }
  .modal-content {
    width: max-content;
  }
  .modal-body {
    padding: 0px !important;
  }
}
</style>
